package fr.manyverse.app.presentation.auth

import androidx.compose.runtime.Composable

@Composable
internal actual fun rememberAppleLauncher(onFallback: () -> Unit): () -> Unit = onFallback
